module.exports = __webpack_public_path__ + "static/media/0124_Small.9791df66.jpg";